import { jsxs as f, jsx as r } from "react/jsx-runtime";
import { Combobox as H, Label as J, ComboboxInput as K, ComboboxButton as Q, Transition as U, ComboboxOptions as X, ComboboxOption as Y } from "@headlessui/react";
import { useMemo as Z, useRef as ee, useState as p, useEffect as b, Fragment as te } from "react";
import { tv as re } from "../tailwind-variants.config.js";
import { ChevronDownIcon as oe } from "../Icons/basic/ChevronDownIcon.js";
import { typedForwardRef as ae, filterOptions as ne, debounce as me } from "./tools.js";
import { ErrorMessage as le } from "../ErrorMessage/index.js";
import { SearchIcon as ie } from "../Icons/objects/SearchIcon.js";
import { CircleLoaderIcon as se } from "../Icons/circle/CircleLoaderIcon.js";
import { Pill as ce } from "../Pill/index.js";
import { MenuItem as je } from "./MenuItem.js";
import { mergeRefs as ue } from "../TextArea/tools.js";
import { isEqual as I } from "radash";
const de = "_root_glemr_1", fe = {
  root: de
}, pe = re({
  slots: {
    selectWrapper: "jm-font-geologica jm-flex jm-flex-col jm-gap-1",
    inputWrapper: "jm-flex jm-group jm-reset-fieldset jm-px-4 jm-rounded-lg jm-box-border jm-gap-2 jm-items-center jm-border jm-border-solid jm-border-jutro-new-warm-gray-500 jm-w-full jm-outline-none jm-bg-white has-[:focus]:jm-border-jutro-new-blue-700 has-[:disabled]:jm-bg-jutro-new-warm-gray-100",
    input: "jm-px-0 jm-py-[9px] jm-peer jm-text-ellipsis jm-whitespace-nowrap jm-overflow-hidden jm-cursor-pointer jm-bg-white jm-w-full disabled:jm-bg-jutro-new-warm-gray-100 disabled:jm-cursor-default jm-border-none focus:jm-outline-none jm-outline-none focus:jm-ring-0 [&::placeholder]:jm-text-jutro-new-warm-gray-500 jm-text-jutro-new-warm-gray-800 jm-font-paragraph-1",
    optionsWrapper: "jm-w-full jm-absolute jm-z-40 jm-max-h-[280px] jm-flex jm-flex-col jm-gap-1 jm-p-2 jm-box-border jm-overflow-auto jm-rounded jm-border jm-border-solid jm-border-jutro-new-warm-gray-500 jm-bg-white jm-text-jutro-new-warm-gray-800 focus:jm-outline-none"
  },
  variants: {
    error: {
      true: {
        inputWrapper: "has-[:focus]:jm-border-transparent jm-border-transparent jm-outline jm-outline-offset-0 jm-outline-2 jm-outline-jutro-new-rose-600"
      }
    },
    isSearchable: {
      true: {
        input: "jm-cursor-text"
      },
      false: {
        input: "selection:jm-bg-transparent"
      }
    },
    optionsPosition: {
      bottom: { optionsWrapper: "jm-mt-2" },
      top: { optionsWrapper: "jm-bottom-[52px]" }
    },
    full: {
      true: { selectWrapper: "jm-w-full" },
      false: { selectWrapper: "jm-w-fit" }
    }
  },
  defaultVariants: {
    full: !0,
    optionsPosition: "bottom"
  }
}), Ae = ae(
  (o, P) => {
    const {
      label: y,
      onChange: k,
      value: t,
      error: v,
      onInputChange: C,
      noOptionsMessage: O,
      disabled: s,
      placeholder: E,
      isAsync: m,
      onBlur: N,
      isSearchable: c,
      onOptionsMenuToggle: g,
      optionsPosition: M,
      full: B,
      ...V
    } = o, a = Array.isArray(t), $ = "valueAsPill" in o && o.valueAsPill, T = !!("clearAfterSelect" in o && o.clearAfterSelect), w = Z(
      () => "options" in o ? o.options : [],
      [o]
    ), S = ee(null), [h, j] = p(w), [z, W] = p(!1), [i, l] = p(!1), [u, d] = p("");
    b(() => {
      (async () => {
        if (!(!t || a)) {
          if (m) {
            const e = await o.loadOptions(t.label);
            j(e);
          }
          d(t.label);
        }
      })();
    }, []), b(() => {
      m || j(w);
    }, [m, w]), b(() => {
      g && g(i);
    }, [i, g]), b(() => {
      a || d((t == null ? void 0 : t.label) ?? "");
    }, [a, t]);
    const { selectWrapper: F, inputWrapper: D, input: L, optionsWrapper: _ } = pe({
      error: !!v,
      isSearchable: c,
      full: B,
      optionsPosition: M
    }), R = (e) => a ? t.some(({ value: n }) => I(e.value, n)) : I(e.value, t == null ? void 0 : t.value), x = (e) => a || !c || !i ? (e == null ? void 0 : e.label) || u : "", A = !a && u !== (t == null ? void 0 : t.label);
    return /* @__PURE__ */ f("div", { className: `${F()} ${fe.root}`, children: [
      /* @__PURE__ */ f(
        H,
        {
          immediate: !c,
          disabled: s,
          value: a ? null : t,
          onChange: (e) => {
            T && (l(!1), d("")), !(e && R(e)) && k(e);
          },
          by: "value",
          children: [
            y && /* @__PURE__ */ r(J, { className: "jm-font-label jm-text-jutro-new-warm-gray-800", children: y }),
            /* @__PURE__ */ f("div", { className: "jm-pointer-events-auto jm-relative", children: [
              /* @__PURE__ */ f("fieldset", { className: D(), disabled: s, children: [
                c && /* @__PURE__ */ r(
                  "div",
                  {
                    className: "jm-mr-[6px] jm-grid jm-cursor-text jm-place-items-center jm-text-jutro-new-warm-gray-800 group-disabled:jm-cursor-default",
                    onClick: () => {
                      var e;
                      return (e = S.current) == null ? void 0 : e.focus();
                    },
                    children: /* @__PURE__ */ r(ie, { size: "sm" })
                  }
                ),
                !a && (t == null ? void 0 : t.leftElement) && !A && x(t) && /* @__PURE__ */ r("div", { className: "jm-grid jm-place-items-center", children: t.leftElement }),
                /* @__PURE__ */ r(
                  K,
                  {
                    ...V,
                    ref: ue(P, S),
                    type: "search",
                    autoComplete: "new-password",
                    onBlur: () => {
                      l(!1), N && N();
                    },
                    readOnly: !c,
                    onClick: async () => {
                      if (!(h.length === 0 && !u)) {
                        if (i) {
                          l(!1);
                          return;
                        }
                        if (m && o.shouldReloadOptionsOnClick && u) {
                          const e = await o.loadOptions(u);
                          j(e);
                        }
                        l(!0);
                      }
                    },
                    placeholder: E,
                    className: L(),
                    displayValue: x,
                    onChange: async (e) => {
                      const n = e.target.value.trim();
                      C && C(n), d(n);
                      const q = m ? o.loadOptions : ne;
                      me(async () => {
                        if (m && !n) {
                          l(!1), setTimeout(() => {
                            j([]);
                          }, 200);
                          return;
                        }
                        W(!0);
                        const G = await q(
                          n,
                          m ? void 0 : o.options
                        );
                        j(G), l(!0), W(!1);
                      });
                    }
                  }
                ),
                !a && (t == null ? void 0 : t.rightElement) && !A && x(t) && /* @__PURE__ */ r("div", { className: "jm-grid jm-place-items-center", children: t.rightElement }),
                z && /* @__PURE__ */ r("div", { className: "jm-grid jm-animate-spin jm-place-items-center jm-text-jutro-new-warm-gray-800", children: /* @__PURE__ */ r(se, { size: "sm" }) }),
                !m && /* @__PURE__ */ r(
                  Q,
                  {
                    onClick: () => l((e) => !e),
                    disabled: s,
                    className: `${i && "jm-custom-rotate-180"} jm-grid jm-cursor-pointer jm-place-items-center jm-border-none jm-bg-transparent jm-p-0 jm-text-jutro-new-warm-gray-800 jm-transition peer-disabled:jm-cursor-default peer-disabled:jm-text-jutro-new-warm-gray-500`,
                    children: /* @__PURE__ */ r(oe, { size: "sm" })
                  }
                )
              ] }),
              /* @__PURE__ */ r(
                U,
                {
                  as: te,
                  leave: "jm-transition jm-ease-in jm-duration-75",
                  leaveFrom: "jm-opacity-100",
                  leaveTo: "jm-opacity-0",
                  enter: "jm-transition jm-ease-out jm-duration-75",
                  enterFrom: "jm-opacity-0",
                  enterTo: "jm-opacity-100",
                  show: i,
                  children: /* @__PURE__ */ r(
                    X,
                    {
                      static: !0,
                      modal: !1,
                      className: _(),
                      children: h.length === 0 ? /* @__PURE__ */ r("div", { className: "jm-font-paragraph-2 jm-select-none jm-py-3 jm-text-center jm-leading-[18px]", children: O || "Brak wyników" }) : h.map((e, n) => /* @__PURE__ */ r(
                        Y,
                        {
                          value: e,
                          onClick: () => {
                            a || l(!1);
                          },
                          children: /* @__PURE__ */ r(
                            je,
                            {
                              option: e,
                              selected: R(e),
                              disabled: s,
                              onRemove: "onRemove" in o && o.onRemove ? o.onRemove : void 0
                            }
                          )
                        },
                        e.label + n
                      ))
                    }
                  )
                },
                a ? `multi-${t.length}` : null
              )
            ] })
          ]
        }
      ),
      a && $ ? /* @__PURE__ */ r("div", { className: "jm-flex jm-flex-wrap jm-gap-2", children: t.map((e, n) => /* @__PURE__ */ r(
        ce,
        {
          label: e.label,
          onClick: () => {
            o.onRemove(e);
          },
          disabled: s
        },
        `${e.label}-${n}`
      )) }) : null,
      /* @__PURE__ */ r(le, { error: v })
    ] });
  }
);
export {
  Ae as Select
};
//# sourceMappingURL=index.js.map
